/*
* @描述: 开票弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-13 17:12:32
*/
<template>
    <div>
        <el-dialog :before-close="handleDialogClose"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :modal-append-to-body="false"
                   :visible.sync="dialogVisible"
                   class="custom_form_dialog invoice_dialog"
                   title="新建开票"
                   width="620px">
            <div v-loading="loading">
                <el-form ref="invoiceForm"
                         :model="invoiceForm"
                         :rules="invoiceFormRules"
                         label-position="top"
                         size="small">
                    <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                        <el-col :span="12">
                            <el-form-item label="关联订单" prop="order_num">
                                <el-select v-model="invoiceForm.order_num"
                                           :disabled="source==='detail'"
                                           placeholder="请选择关联订单"
                                           @focus="handleOrderSelectFocus">
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="待回款金额" prop="order_num">
                                <el-input v-model="orderDetailsData.can_receivable_amount" disabled
                                          placeholder="自动带出"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="可开票金额" prop="can_invoice_amount">
                                <el-input v-model="orderDetailsData.can_invoice_amount" disabled
                                          placeholder="自动带出"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开票公司" prop="invoice_company_name">
                                <el-select v-model="invoiceForm.invoice_company_name"
                                           placeholder="请选择开票公司">
                                    <el-option v-for="item in relateCustomList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.name"
                                               @click.native="handleInvoiceCompanySelect(item)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客户联系人" prop="contact_name">
                                <el-input v-model="orderDetailsData.contact_name" disabled
                                          placeholder="自动带出"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发票类型" prop="invoice_type">
                                <el-select v-model="invoiceForm.invoice_type"
                                           placeholder="请选择发票类型"
                                           @change="handleInvoiceTypeChange">
                                    <el-option :value="1" label="电子专票"></el-option>
                                    <el-option :value="2" label="电子普票"></el-option>
                                    <el-option :value="3" label="纸质专票"></el-option>
                                    <el-option :value="4" label="纸质普票"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="invoiceForm.invoice_type===1||invoiceForm.invoice_type===2" :span="12">
                            <el-form-item label="电子发票提供方式" prop="invoice_method">
                                <el-select v-model="invoiceForm.invoice_method"
                                           placeholder="请选择电子发票提供方式"
                                           @change="handleInvoiceMethodsChange">
                                    <el-option :value="1" label="邮箱"></el-option>
                                    <el-option :value="2" label="二维码"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="invoiceForm.invoice_type===1||invoiceForm.invoice_type===2" :span="12">
                            <el-form-item label="电子收票邮箱" prop="invoice_email">
                                <el-input v-model="invoiceForm.invoice_email"
                                          placeholder="请输入电子收票邮箱"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="本次开票金额" prop="invoice_amount">
                                <el-input v-model="invoiceForm.invoice_amount"
                                          placeholder="请输入本次开票金额"
                                          @blur="handleInvoiceAmountInputBlur"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开票对象" prop="invoice_title_type">
                                <el-select v-model="invoiceForm.invoice_title_type" plaeholder="请选择开票对象">
                                    <el-option :value="1" label="个人"></el-option>
                                    <el-option :value="2" label="单位"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="开票信息" prop="invoice_info">
                                <el-input v-model="invoiceForm.invoice_info"
                                          :rows="4"
                                          placeholder="自动带出关联客户的开票信息，可修改"
                                          type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="invoiceForm.invoice_type===3||invoiceForm.invoice_type===4" :span="12">
                            <el-form-item label="收货人" prop="receive_name">
                                <el-input v-model="invoiceForm.receive_name" placeholder="请输入收货人"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="invoiceForm.invoice_type===3||invoiceForm.invoice_type===4" :span="12">
                            <el-form-item label="收货人电话" prop="receive_phone">
                                <el-input v-model="invoiceForm.receive_phone"
                                          placeholder="请输入收货人电话"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="invoiceForm.invoice_type===3||invoiceForm.invoice_type===4" :span="24">
                            <el-form-item label="收货地址" prop="receive_addr">
                                <el-input v-model="invoiceForm.receive_addr"
                                          placeholder="请输入收货地址"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注" prop="apply_remark">
                                <el-input v-model="invoiceForm.apply_remark"
                                          :rows="4"
                                          placeholder="请输入备注信息"
                                          type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="附件" prop="apply_attachments">
                                <div class="file_upload_wrap">
                                    <div v-if="invoiceForm.apply_attachments.length===0" class="file_outer_wrap">
                                        <img alt=""
                                             src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                             width="36">
                                        <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                        <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                        <input class="upload_input"
                                               multiple
                                               type="file"
                                               @change="handleUploadFileChange($event)">
                                    </div>
                                    <ul v-else class="upload_file_list">
                                        <li v-for="(file,file_idx) in invoiceForm.apply_attachments"
                                            class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img alt="" class="file_img"
                                                     src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"
                                                            effect="dark"
                                                            placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="删除"
                                                            effect="dark"
                                                            placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="invoiceForm.apply_attachments.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                        <li class="upload_file_btn_wrap">
                                            <i class="el-icon-plus"></i>
                                            <span>上传附件</span>
                                            <input class="upload_input"
                                                   multiple
                                                   type="file"
                                                   @change="handleUploadFileChange($event)">
                                        </li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleDialogClose">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickConfirm">确定</el-button>
            </div>
        </el-dialog>
        <RelateOrderSelect v-if="selectOrderDialog"
                           :dialog-visible.sync="selectOrderDialog"
                           :projectId="projectId"
                           @success="handleClickOrderRow"/>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
    </div>
</template>
<script>
import {uploadImg} from "@/utils/uploadOss";
import {formatFileSize} from "@/utils";
import {
    getFormFields,
    invoiceCreateOrder,
    InvoiceDetail,
    invoiceInfoByOrder,
} from "@/api";
import {pagination} from "@/mixins";
import RelateOrderSelect from "@/views/pc/Order/component/relate_order_selet_dialog";

export default {
    name: "InvoiceDialog",
    data() {
        return {
            invoiceForm: {
                order_num: "", //订单编号
                invoice_company_name: "", //开票公司名称
                apply_time: "", //申请开票日期
                invoice_title_type: '', //发票抬头类型 1=个人 2=单位 , 订单里叫【开票对象】
                invoice_type: '', //发票类型 1:电子专票, 2:电子普票, 3:纸质专票, 4:纸质普票
                invoice_amount: "", //申请开票金额
                invoice_info: "", //开票信息     长文本
                apply_remark: "", // 申请备注
                apply_attachments: [], // 申请附件，JSON格式
                invoice_method: '', //发票提供方式: 1邮箱 2二维码 3其他 (根据实际情况定义)
                invoice_email: "", //  邮箱
                invoice_object: "", // 开票对象 未使用传空
                receive_name: '',
                receive_phone: '',
                receive_addr: ''
            },
            invoiceFormRules: {
                invoice_company_name: [{required: true, message: '请选择开票公司', trigger: 'change'}],
                invoice_type: [{required: true, message: '请选择发票类型', trigger: 'change'}],
                invoice_method: [{required: true, message: '请选择发票提供方式', trigger: 'change'}],
                invoice_email: [{required: true, message: '请输入邮箱', trigger: 'blur'}, {
                    type: 'email',
                    message: '请输入正确的邮箱',
                    trigger: ['blur', 'change']
                }],
                invoice_amount: [{required: true, message: '请输入本次开票金额', trigger: 'blur'}],
                invoice_info: [{required: true, message: '请输入开票信息', trigger: 'blur'}],
                receive_name: [{required: true, message: '请输入收货人', trigger: 'blur'}],
                receive_phone: [{required: true, message: '请输入收货人电话', trigger: 'blur'}],
                receive_addr: [{required: true, message: '请输入收货地址', trigger: 'blur'}],
                invoice_title_type: [{required: true, message: '请选择开票对象', trigger: 'change'}],
            },
            orderDetailsData: {
                contact_name: '',
                can_receivable_amount: '',
                can_invoice_amount: '',
            },
            loading: false,
            selectOrderDialog: false,
            relateCustomList: [],
            invoice_info_auto: true,
            previewImgSrc: '',
            previewImgList: []
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: [Number, String],
            default: 0,
        },
        source: {
            type: String,
            default: 'list'
        },
        invoice_no: {
            type: String,
            default: ''
        },
        projectId: {
            type: Number,
            default: 0,
        },
    },
    mixins: [pagination],
    components: {RelateOrderSelect},
    created() {
        if (this.order_id && this.source === 'detail') {
            this.invoiceForm.order_num = this.order_id
            this.getOrderDetail(this.order_id)
        }
        if (this.invoice_no) {
            this.getInvoiceDetail()
        }
    },
    mounted() {
    },
    methods: {
        //获取订单详情
        getOrderDetail(order_num) {
            this.loading = true
            invoiceInfoByOrder({
                order_num
            }).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData = res.data
                    this.relateCustomList = res.data.customer_list
                    this.invoiceForm.receive_addr =  this.invoiceForm.receive_addr ? this.invoiceForm.receive_addr  : res.data.receive_addr
                    this.invoiceForm.receive_phone = this.invoiceForm.receive_phone ?  this.invoiceForm.receive_phone : res.data.receive_phone
                    this.invoiceForm.receive_name = this.invoiceForm.receive_name ?  this.invoiceForm.receive_name : res.data.receive_name
                    getFormFields({
                        field_form: "customers"
                    }).then(res => {
                        if (res.code === 200) {
                            const invoice_note_field = res.data.find(item => item.field_key === 'invoice_note')
                            this.invoice_info_auto = !invoice_note_field.extend.initial_display
                            if (this.relateCustomList.length) {
                                const company = this.relateCustomList[0]
                                this.invoiceForm.invoice_company_name = company.name
                                if (this.invoice_info_auto) {
                                    this.invoiceForm.invoice_info = company.invoice_note
                                }
                                this.$set(this.orderDetailsData, 'contact_name', company.customer_contacts && company.customer_contacts.length ? company.customer_contacts[0].name : '')
                            }
                        }
                        this.loading = false
                    })
                } else {

                    this.loading = false
                }
            })
        },

        // 详情
        getInvoiceDetail() {
            this.loading = true;
            InvoiceDetail({invoice_no: this.invoice_no}).then((res) => {
                if (res.code === 200) {
                    this.invoiceForm.order_num = res.data.order_info.order_no
                    this.invoiceForm.invoice_company_name = res.data.invoice_info.invoice_company_name
                    this.invoiceForm.invoice_type = res.data.invoice_info.invoice_type
                    this.invoiceForm.invoice_method = res.data.invoice_info.invoice_method
                    this.invoiceForm.invoice_email = res.data.invoice_info.invoice_email
                    this.invoiceForm.invoice_amount = res.data.invoice_info.invoice_amount
                    this.invoiceForm.apply_remark = res.data.invoice_info.remark
                    this.invoiceForm.apply_attachments = res.data.invoice_info.attachments
                    this.invoiceForm.invoice_title_type = res.data.invoice_info.invoice_title_type
                    this.invoiceForm.receive_addr = res.data.invoice_info.receive_addr
                    this.invoiceForm.receive_name = res.data.invoice_info.receive_name
                    this.invoiceForm.receive_phone = res.data.invoice_info.receive_phone
                    this.invoiceForm.invoice_info = res.data.invoice_info.invoice_info
                    this.getOrderDetail(this.order_id)
                } else {
                    ;
                }
                this.loading = false;
            });
        },

        handleOrderSelectFocus() {
            this.selectOrderDialog = true
        },

        //本次回款金额输入框失焦事件
        handleInvoiceAmountInputBlur() {
            let val = this.invoiceForm.invoice_amount.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            if (amount === 0) {
                this.$message.error('本次开票金额不能为0')
                this.invoiceForm.invoice_amount = ''
            } else if (amount > Number(this.orderDetailsData.can_invoice_amount)) {
                this.$message.error('本次开票金额不能大于可开票金额')
                this.invoiceForm.invoice_amount = Number(this.orderDetailsData.can_invoice_amount).toFixed(2)
            } else {
                this.invoiceForm.invoice_amount = amount.toFixed(2);
            }
        },

        //电子发票提供方式切换事件
        handleInvoiceMethodsChange(val) {
            if (val === 1) {
                this.invoiceFormRules.invoice_email[0].required = true
            } else {
                this.invoiceFormRules.invoice_email[0].required = false
                this.$refs.invoiceForm.clearValidate('invoice_email')
            }
        },

        //发票类型切换事件
        handleInvoiceTypeChange(val) {
            if (val === 3 || val === 4) {
                this.invoiceForm.receive_name = this.orderDetailsData.receive_name
                this.invoiceForm.receive_phone = this.orderDetailsData.receive_phone
                this.invoiceForm.receive_addr = this.orderDetailsData.receive_addr
            } else {
                this.invoiceForm.receive_name = ''
                this.invoiceForm.receive_phone = ''
                this.invoiceForm.receive_addr = ''
            }
            this.invoiceForm.invoice_method = ''
            this.invoiceForm.invoice_email = ''
        },

        //上传文件
        handleUploadFileChange(e) {
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$message.error('附件大小不能超过50m')
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.invoiceForm.apply_attachments.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //点击选择订单
        handleClickOrderRow(row) {
            this.invoiceForm.order_num = row.order_num
            this.getOrderDetail(row.order_num)
        },

        //点击切换关联客户
        handleInvoiceCompanySelect(item) {
            if (this.invoice_info_auto) {
                this.invoiceForm.invoice_info = item.invoice_note
            }
            if (item.customer_contacts.length) {
                this.$set(this.orderDetailsData, 'contact_name', item.customer_contacts[0].name)
            }
        },

        //点击查看商机详情
        handleClickBusinessDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: row.project_id,
                    name: row.project_name,
                },
            });
        },

        //点击查看关联客户详情
        handleClickCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.customer_name,
                },
            });
        },

        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id,
                    name: row.order_num,
                },
            });
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:invoice_no', '')
        },

        //确定事件
        handleClickConfirm() {
            this.$refs.invoiceForm.validate(valid => {
                if (valid) {
                    invoiceCreateOrder(this.invoiceForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success('开票申请提交成功')
                            this.$emit('update:dialogVisible', false)
                            this.$emit('refresh')
                        } else {

                        }
                    })
                } else {
                    return false
                }
            })
        },
    },
}
</script>
<style lang="scss">
.invoice_dialog .el-dialog__body {
    padding: 24px;

    .el-select {
        width: 100%;
    }

    .custom_detail_form .el-form-item {
        margin-bottom: 16px;
    }
}
</style>